import { TabItem } from 'components/DesignSystem/Tabs';

export const tabsArrData: TabItem[] = [
    {
        value: 'cardDetails',
        label: 'Card Details',
    },
    {
        value: 'activityDetails',
        label: 'Activity Details',
    },
    {
        value: 'activityRelationships',
        label: 'Activity Relationships',
    },
    {
        value: 'relatedCards',
        label: 'Associated Activities',
    },
    {
        value: 'auditLogs',
        label: 'Audit Log',
    },
];
